import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { highlightBlueBase, fontFamilyOpenSans, grayLight30, grayLight20 } from '../../constants/principles'
import Spinner from '../generic/spinner.js'
import { breakpoints } from '../../constants'

export const BodyDivFlex = ({ children }) => <StyledBodyDivFlex id={'BodyDivFlex'}>{children}</StyledBodyDivFlex>

const StyledBodyDivFlex = styled.div`
  padding-left: 16px;
  padding-right: 16px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  @media (min-width: ${breakpoints.lg}px) {
    width: 1024px;
  }
  max-width: 1024px;
  font-family: ${fontFamilyOpenSans};
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const FlexDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
export const FlexRowDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
export const ModalContentNormal = styled.div`
  border-top: 6px solid ${grayLight20};
  border-bottom: 1px solid ${grayLight20};
  width: 100%;
  overflow-y: auto;
`
export const ModalContentNoBorder = styled.div`
  width: 100%;
  overflow-y: auto;
`
export const AnchorButton = styled.button`
  text-decoration: none;
  cursor: pointer;
  color: ${highlightBlueBase};
  font: inherit;
  outline: none;
  border: none;
  background: none;
  :hover {
    text-decoration: underline;
  }
`
export const Line = styled.div`
  border-bottom: 1px solid ${grayLight30};
  margin: 40px 0px;
  width: ${p => p.width || 100}%;
`
export const BackgroundImage = styled.div`
  z-index: -1;
  background-image: url(${p => p.background});
  background-position: center top;
  background-repeat: no-repeat, repeat;
  background-size: contain;
  width: ${p => p.width}px;
  height: ${p => p.height}px;
  margin-top: ${p => p.marginTop}px;
  margin-bottom: ${p => p.marginBottom}px;
`
const SpinImageDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: hidden;
  ${p => p.image && `background-image: url(${p.image});`};
  background-repeat: no-repeat;
  background-size: contain;
  width: ${p => p.width}px;
  height: ${p => p.width * 0.75}px;
  margin: -${p => p.width / 8}px 0px;
  ${p =>
    p.sideMode &&
    `
    position: absolute;
    opacity: 1;
    right: 0;
    bottom: 0;
    transform: translate(140px,-50px);
    `}
`

export const SpinnerImage = ({ imgUrl, sideMode, size, imgMarginTop, width }) => {
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    let mounted = true
    setIsLoading(true)
    const onload = () => setTimeout(() => mounted && setIsLoading(false), 150)
    if (imgUrl) {
      var img = new Image()
      img.src = imgUrl
      img.onload = onload
    }
    return () => (mounted = false)
  }, [imgUrl])
  return (
    <SpinImageDiv data-testid={'basic-spining-image'} sideMode={sideMode} image={imgUrl} width={width} marginTop={imgMarginTop}>
      {isLoading && <Spinner size={size} />}
    </SpinImageDiv>
  )
}

export const LoadingImage = ({ displayImages, images, spinnerSize, imgMarginTop, imgWidth = 105 }) => {
  return images && displayImages ? <SpinnerImage key={images.url || 'null'} imgMarginTop={imgMarginTop} size={spinnerSize} width={imgWidth} imgUrl={process.env.BUILD_STAGE !== 'build-html' && images.url} /> : false
}
